import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';

import PropTypes from 'prop-types';

import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { ReactComponent as GroupIcon } from '../../img/search_page/search_bar/group.svg';
import { styled } from '@mui/material/styles';
import { lightBlue } from '@mui/material/colors';

import Analytics from 'arbitrip-common/client/analytics';
import { withTranslation } from 'react-i18next';

const group_booking_request_url = process.env.REACT_APP_GROUP_BOOKING_REQUEST_URL;

const styles = (theme) => ({
	companies: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
	},
	button: {
		width: 195,
		height: 45,
		border: '1px solid #275180',
		color: '#275180',
		overflow: 'hidden',
		position: 'relative',

		fontFamily: 'Lato',
		fontSize: 14,
		fontWeight: 700,
		lineHeight: '17px',
		letterSpacing: 0,
		textAlign: 'center',
		'& .MuiButton-startIcon': {
			margin: 0,
			marginInlineEnd: 8,
		},
	},
	ribbon: {
		background: '#FF9D0A',
		color: '#FAFAFA',
		transform: 'rotate(45deg)',
		position: 'absolute',
		top: 8,
		right: -37,
		width: 100,

		// width: 56,
		height: 12,
		// top: -10.5,
		// left: 165.5,

		fontFamily: 'Lato',
		fontSize: 11,
		fontWeight: 500,
		lineHeight: '11px',
		letterSpacing: 0,
		textAlign: 'center',
	},
	font: {
		fontSize: 18,
		color: theme.palette.white,
		textShadow: '0 0 13px rgba(0,0,0,.4)',
	},
	fontDark: {
		fontSize: 18,
		color: theme.palette.black.main,
	},
	dialogPaper: {
		padding: 24,
		width: 524,
		height: 603,
		textAlign: 'center',
		borderRadius: 10,
	},
	dialogTitle: {
		// width: 152,
		// height: 25,
		marginTop: 36,

		fontSize: 21,
		fontWeight: 800,
		lineHeight: '25px',
		letterSpacing: 0,
		textAlign: 'center',

		color: 'var(--general-colors-black)',
	},
	dialogContentContainer: {
		overflow: 'hidden',
	},
	dialogContent: {
		// width: 444,
		// height: 126,
		// marginTop: 8,
		marginTop: 10,

		fontFamily: 'Lato',
		fontSize: 15,
		fontWeight: 400,
		lineHeight: '21px',
		letterSpacing: 0,

		color: 'var(--general-colors-black)',

		// textWrap: 'balance'
		textAlign: 'justify',
		wordBreak: 'keep-all',
		padding: '0 5%',
		direction: 'inherit',
	},
	dialogActions: {
		justifyContent: 'center',
	},
	dialogButton: {
		height: 41,
		borderRadius: 5,

		fontFamily: 'Lato',
		fontSize: 14,
		fontWeight: 700,
		lineHeight: '17px',
		letterSpacing: 0,
		textAlign: 'center',

		color: '#275180',
		textTransform: 'none',
	},
});

const ColorButton = styled(Button)(({ theme }) => ({
	color: theme.palette.getContrastText(lightBlue[100]),
	backgroundColor: lightBlue[100],
	'&:hover': {
		backgroundColor: lightBlue[200],
	},
}));

class GroupBookings extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			group_bookings_modal_open: false,
		};

		this.openGroupBookingsModal = this.openGroupBookingsModal.bind(this);
		this.handleGroupBookingsModalClose = this.handleGroupBookingsModalClose.bind(this);
		this.openGroupBookingRequestUrl = this.openGroupBookingRequestUrl.bind(this);
	}

	openGroupBookingsModal() {
		this.setState({ group_bookings_modal_open: true });

		Analytics.actions.interactions.showGroupBookingsModal(this.props.profile);
	}

	handleGroupBookingsModalClose() {
		this.setState({ group_bookings_modal_open: false });
	}

	openGroupBookingRequestUrl() {
		window.open(group_booking_request_url, '_blank', 'noreferrer');

		Analytics.actions.interactions.openGroupBookingRequestForm(this.props.profile);
	}

	render() {
		let { classes, t, theme } = this.props;

		return (
			<div className={classes.companies}>
				<ColorButton
					component="label"
					variant="contained"
					startIcon={<GroupIcon />}
					onClick={this.openGroupBookingsModal}
					className={classes.button}
				>
					{t('GroupBookings.Title')}
					{/* <div className={classes.ribbon}>NEW</div> */}
				</ColorButton>
				<Dialog
					onClose={this.handleGroupBookingsModalClose}
					open={this.state.group_bookings_modal_open}
					classes={{ paper: classes.dialogPaper }}
				>
					<IconButton
						aria-label="close"
						onClick={this.handleGroupBookingsModalClose}
						sx={{
							position: 'absolute',
							insetInlineEnd: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
					<DialogContent className={classes.dialogContentContainer}>
						<img
							className="empty-state-image"
							src="./img/search_page/search_bar/group_bookings.svg"
							alt="no results"
						></img>
						<Typography className={classes.dialogTitle}>{t('GroupBookings.Title')}</Typography>
						<Typography className={classes.dialogContent}>{t('GroupBookings.Description')}</Typography>
					</DialogContent>
					<DialogActions className={classes.dialogActions}>
						<ColorButton
							component="label"
							variant="contained"
							onClick={this.openGroupBookingRequestUrl}
							className={classes.dialogButton}
						>
							{t('GroupBookings.CreateRequest')}
						</ColorButton>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

GroupBookings.propTypes = {
	classes: PropTypes.object.isRequired,
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default withTranslation()(withTheme(withStyles(styles)(GroupBookings)));
